var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"observe-cover-map"},[_c('part-title',{attrs:{"title":"覆盖率统计"}}),_c('div',{ref:"hChart",staticClass:"observe-cover-map__map"}),_c('div',{ref:"time-line",staticClass:"observe-cover-map__timeline"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }